module.exports = __webpack_public_path__ + "img/dazi_img1.a0298d72.png";